import React from 'react'
import type { InlineInputProps } from '@ztechapps/webui.input'
import { SerialNumberTypeSelectInlineInput } from '../SerialNumberType/SerialNumberTypeSelectInlineInput'

export const SerialNumberTypeInlineInput = (props: InlineInputProps) => {
  return (
    <SerialNumberTypeSelectInlineInput
      displayContent={(e) => e?.value}
      label="Serial Number Type"
      help="The type of serial numbering for this product (Individual or Batch)"
      name="serialNumberType"
      {...props}
    />
  )
}
